import { Container } from "react-bootstrap";
import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";

export default function Exclusions(): ReactElement {
  const { t } = useTranslation();

  const coverageDetails = [
    {
      title: t("sehat_exclusion_cosmetic_treatments_title"),
      captions: [t("sehat_exclusion_cosmetic_treatments_caption")]
    },
    {
      title: t("sehat_exclusion_dental_treatment_title"),
      captions: [t("sehat_exclusion_dental_treatment_caption")]
    },
    {
      title: t("sehat_exclusion_self_inflicted_title"),
      captions: [t("sme_exclusions_self_inflicted_captions")]
    },
    {
      title: t("sehat_exclusion_psychiatric_title"),
      captions: [t("travel_exclusions_description4")]
    }
  ];

  return (
    <div className="landing-page-wrapper mt-5">
      <section className="exclusion-section exclusion-pa my-health-takaful-bnr">
        <Container>
          <h1 className="mhtb-title text-center">{t("exclusions")}</h1>
          <p className="mhtb-caption text-center">{t("travel_exclusions_description")}</p>

          <div className="sehatzamin-packages">
            {coverageDetails.map((detail, index) => (
              <div
                key={index}
                className={`col-md-12 d-flex justify-content-between ${
                  index !== coverageDetails.length - 1 ? "border-bottom-ruppees pt-4 pb-4" : "pt-4 pb-4"
                }`}
              >
                <div className="text-start">
                  <h4 className="candb-title crossmark-title">{detail.title}</h4>
                  {/* Map through captions array */}
                  {detail.captions.map((caption, captionIndex) => (
                    <p
                      key={captionIndex}
                      className="candb-caption ms-4 mb-0"
                    >
                      {caption}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
